export const QuestRoute = {
    login: '/accounts/login',
    acceptTos: '/accounts/tos',
    acceptFeature: feature => `/accounts/merchants/features/${feature}`,
    roles: '/accounts/merchants',
    refreshToken: '/accounts/tokens',
    notifications: {
        new: '/notifications',
        edit: id => `/notifications/${id}`
    },
    points: {
        awards: '/points/awards',
        settings: '/points/settings',
        edit: id => `/points/awards/${id}`,
    },
    referral: {
        settings: '/referralProgram/settings',
        awards: '/referralProgram/awards',
        edit: id => `/referralProgram/awards/${id}`,
    },
    birthday: {
        settings: '/birthdayClub/settings',
        awards: '/birthdayClub/awards',
        edit: id => `/birthdayClub/awards/${id}`,
    },
    airPay: {
        settings: '/accounts/airPay',
        // awards: '/birthdayClub/awards',
        // edit: id => `/birthdayClub/awards/${id}`,
    },
    dashboard: {
        daily: '/accounts/dashboard/daily',
        count: '/accounts/dashboard/counts',
        sales: '/accounts/dashboard/sales',
        totals: '/accounts/dashboard/totals',
        incomeByHour: '/accounts/dashboard/income',
        status: '/accounts/locations/kiosks',
        washCount: '/accounts/dashboard/washCount',
        appActivity: '/accounts/dashboard/appActivity',
        passActivity: '/accounts/dashboard/passActivity',
        topWashClub: '/accounts/dashboard/topWashClub',
        topExpressPass: '/accounts/dashboard/topExpressPass',
        loyaltyPoints: '/accounts/dashboard/loyaltyPoints',
        birthdayWashes: '/accounts/dashboard/birthdayWashes',
    },
    invoice: {
        status: id => '/accounts/invoices/' + id,
        refund: id => `/accounts/invoices/${id}/refund`,
    },
    reports: {
        transactions: '/accounts/reports/transactions',
        transaction: '/accounts/reports/transactions/',
        refundTransaction: '/accounts/reports/refundTransaction',
        invoices: '/accounts/reports/invoices',
        invoice: id => '/accounts/invoices/' + id,
        daily: '/accounts/reports/daily',
        revenue: '/accounts/reports/revenue',
        usage: '/accounts/reports/usage',
        models: '/accounts/models',
        hourly: '/accounts/reports/usage/hourly',
        hourlyBar: '/accounts/reports/usage/hourly/graph',
        expiringCard: '/accounts/reports/expiringCards',
        referral: '/accounts/reports/signup',
        washClubUsage: '/accounts/reports/washClubUsage',
        mobile: {
            activity: '/accounts/reports/washClubActivity',
            revenue: '/accounts/reports/appRevenue',
            redeemed: '/accounts/reports/redemptions/washes',
            airPay: '/accounts/reports/airPay',
            promoCode: '/accounts/reports/promoCode',
            claimedDeal: '/accounts/reports/claimedDeal',
            appReferral: '/accounts/reports/appReferral',
            WCReport: '/accounts/reports/washClubUser',
        },
        express: {
            activity: '/accounts/reports/expressPassActivity',
            usage: '/accounts/reports/expressPass',
        },
        code: {
            liability: '/accounts/reports/codeLiability',
            singleUse: '/accounts/reports/singleUseCodes',
        },
        kioskErrorResponseLog: mediaType => `/accounts/reports/KioskErrorResponseLog?mediaType=${mediaType}`
    },
    settings: {
        processor: '/accounts/settings?category=CreditCards',
        exact: '/accounts/settings?category=Exact',
        moneris: '/accounts/settings?category=Moneris',
        monerisReceipt: id => `/payments/accounts/users/${id}/moneris/receipts`,
        worldPay: '/accounts/settings?category=Worldpay',
        IDTech: '/accounts/settings?category=Ips',
        paymentExpress: '/accounts/settings?category=PaymentExpress',
        header: '/accounts/settings?category=Reports',
        email: '/accounts/settings?category=Email',
        testEmail: '/accounts/emails/test',
        appLocations: '/accounts/locations/app',
        giftEmails: '/accounts/giftEmails',
        locations: '/accounts/locations',
        logo: '/accounts/logo',
        account: '/accounts/settings?category=Account',
        activityLog: '/accounts/activityLog',
        support: '/accounts/settings/support',
        userList: '/accounts/userList',
        resetPassword: '/accounts/merchants/update-password',
        updateUser: '/accounts/merchants',
        dashboard: '/accounts/merchants/dashboard',
        app: '/accounts/settings/mobileApp',
        deleteDeviceIDs: '/accounts/users/deviceIds'
    },
    taxesRates: {
        taxes: '/accounts/taxRates',
        edit: id => `/accounts/taxRates/${id}`,
    },
    userManagement: {
        roles: '/roles',
        list: '/accounts/userList',
        resetAccountPassword: `/accounts/forgot-password`,
        edit: id => `/accounts/userList/${id}`,
        resetPassword: id => `/accounts/userList/${id}/resetpassword`,
        audit: id => `/accounts/userList/${id}/audit`
    },
    user: {
        add: '/accounts/users',
        quickSignup: '/accounts/users/quickSignup',
        processor: (GUID) => `/accounts/users/${GUID}/payments`,
        info: (GUID) => `/accounts/users/${GUID}`,
        notes: (GUID) => `/accounts/users/${GUID}/notes`,
        vehicle: (GUID) => `/accounts/users/${GUID}/vehicle`,
        washClub: (GUID) => `/accounts/users/${GUID}/washClub`,
        washClubSettings: (GUID) => `/accounts/users/${GUID}/washClub/settings`,
        washClubSignup: (GUID) => `/accounts/users/${GUID}/washClub/signUp`,
        washClubSignupWithChild: (GUID) => `/accounts/users/${GUID}/washClub/signupwithchild`,
        washClubReactivation: (GUID) => `/accounts/users/${GUID}/washClub/reactivate`,
        washClubSetClubShared: (GUID, plateReadId) => `/accounts/users/${GUID}/washClub/ClubShared/${plateReadId}`,
        washClubKickFromClub: (GUID, plateReadId) => `/accounts/users/${GUID}/washClub/Kick/${plateReadId}`,
        washClubTransactions: (GUID) => `/accounts/users/${GUID}/washClub/transactions`,
        washClubProrate: (GUID) => `/accounts/users/${GUID}/washClub/prorate`,
        removeFromPlan: (GUID) => `/accounts/users/${GUID}/familyPlan/leave`,
        loyaltyPoints: (GUID) => `/accounts/users/${GUID}/points`,
        claimedDeals: (GUID) => `/accounts/users/${GUID}/claimedDeals`,
        creditCard: (GUID) => `/accounts/users/${GUID}/cc`,
        loyaltyCreditCard: (loyaltyAccountId) => `/accounts/users/${loyaltyAccountId}/cc`,
        wallet: (GUID) => `/accounts/users/${GUID}/wallet`,
        purchases: (GUID) => `/accounts/users/${GUID}/purchases`,
        createNotes: (GUID) => `/accounts/users/${GUID}/notes`,
        editNote: (GUID, noteId) => `/accounts/users/${GUID}/notes/${noteId}`,
        mediaIDs: (GUID) => `/loyaltyMembers/${GUID}/media`,
        mediaID: (GUID, id) => `/loyaltyMembers/${GUID}/media/${id}`,
        audit: (GUID) => `/accounts/users/${GUID}/audit`,
        resendSignup: (GUID) => `/accounts/users/${GUID}/washClub/resendText`,
        deviceId: (GUID) => `/accounts/users/${GUID}/deviceID`,
        invoice: (GUID) => `/accounts/users/${GUID}/invoices`,
        getBD: (GUID) => `/accounts/users/${GUID}/BD`,
        resendConfirmation: (GUID) => `/accounts/users/${GUID}/emails/confirmation`,
        accountBalance: (GUID) => `/accounts/users/${GUID}/customerAppCredit`,
        search: `/users/search`,
        clearLockout: (GUID) => `/accounts/users/${GUID}/clearLockout`,
        kioskErrorResponseLog: (GUID) => `/accounts/users/${GUID}/kioskErrorResponseLog`
    },
    loyaltyMedia: {
        mediaLookup: '/loyaltyMedia/mediaLookup'    
    },
    loyaltyUser: {
        info: (ID) => `/loyaltyAccounts/${ID}`,
        member: (ID) => `/loyaltyMembers/${ID}`,
        mediaID: (GUID, id) => `/loyaltyMembers/${GUID}/media/${id}`,
        kioskErrorResponseLog: ID => `/loyaltyAccounts/${ID}/KioskErrorResponseLog`
    },
    plateReads: {
        list: '/plateReads',
        vistors: '/plateReads/visitors',    
        customer: id => `/plateReads/${id}`,
        plate: plate => `/plateReads/plate/${plate}`, 
        customerAwards: plate => `/plateReads/plate/${plate}/awards`,
        customerMessages: plate => `/plateReads/plate/${plate}/messages`,             
        plateAwards: '/plateReads/loyaltyAwards',
        plateAward: id => `/plateReads/loyaltyAwards/${id}`,
        awards: id => `/plateReads/awards/${id}`,
        messages: id => `/plateReads/messages/${id}`,
        settings: '/plateReads/settings',
        markResolved: '/plateReads/markResolved',
        updateCustomer: '/plateReads/updateCustomer',
        removeCustomer: '/plateReads/removeCustomer'

    },
    products: {
        edit: id => `/accounts/products/${id}`,
        all: '/accounts/products',
        washClubs: '/accounts/products?type=AppClub',
        washes: '/accounts/products?type=AppWash',
        appCredits: '/accounts/products?type=AppCredit&isEnabled=false',
        kioskItems: '/accounts/settings/kiosks',
        loyaltyTypes: '/loyaltySettings/types'
    },
    fulfillment: {
        products: '/fulfillment/products',
        edit: id => `/fulfillment/products/${id}`,
        orders: '/fulfillment/orders',
        editOrder: id => `/fulfillment/orders/${id}`
    },
    kiosks: {
        items: '/accounts/kioskItems',
        edit: id => '/accounts/kioskItems/' + id,
        wash: '/accounts/kioskItems?itemType=Wash',
        codeBundle: '/accounts/kioskItems?itemType=codeBundle',
        terms: '',
    },
    items: {
        hourly: '/accounts/reports/items?type=hourly',
        passes: '/accounts/reports/items?type=usage'
    },
    washClubs: {
        clubs: '/accounts/washClubs',
        edit: (id) => `/accounts/washClubs/${id}`,
        detail: '/accounts/washClubs/details',
        details: '/accounts/washClubs/settings/details',
        terms: '/loyaltySettings/terms',
        signupMessages: '/loyaltySettings/signupMessages',
        messages: '/accounts/washClubs/messages',
        message: (id) => `/accounts/washClubs/messages/${id}`,
        messageAssignments: '/accounts/washClubs/messages/assignments',
        settings: '/accounts/washClubs/settings',
        pausedAccounts: '/accounts/washClubs/billing',
    },
    expressPass: {
        types: '/loyaltySettings/types',
        allowedTypes: (id) => `/loyaltySettings/types?loyaltyAccountId=${id}`,
        //media: '/expressPass/media', //moved to LoyaltyMedia/MediaLookup endpoint and service
        users: '/expressPass',
        awards: '/loyaltyAwards',
        // signupAwards: (type, id) => `/loyaltyAwards/types?loyaltyType=${type}&loyaltyAccountId=${id}`,
        signupAwards: `/loyaltyAwards/signUp`,
        editAward: (id) => `/loyaltyAwards/${id}`,
        settings: '/expressPass/settings',
        programNames: '/expressPass/programNames',
        messages: '/expressPass/messages',
        message: (id) => `/expressPass/messages/${id}`,
        messageAssignments: '/expressPass/messages/assignments',
        resignUp: guid => `/expressPass/${guid}/reSignup`,
        reactivation: guid => `/expressPass/${guid}/reactivate`,
        deactivation: guid => `/expressPass/${guid}/deactivate`,
        completeSignup: guid => `/expressPass/${guid}/completeSignup`,
    },
    codes: {
        singleUse: '/accounts/codes/singleUse',
        singleUseSettings: '/accounts/codes/singleUse/settings',
        editSingleUse: id => `/accounts/codes/singleUse/${id}`,
        void: id => `/accounts/codes/${id}`,
        washBundle: '/accounts/codes/bundles',
        washBundleSettings: '/accounts/codes/bundles/settings',
        editWashBundle: id => `/accounts/codes/bundles/${id}`,
        washBundleItems: '/accounts/codes/bundles/items',
        receipt: '/accounts/codes/receipts',
        editReceipt: id => `/accounts/codes/receipts/${id}`,
        issueReceipt: `/accounts/codes/receipts/settings`,
        bundleGrid: `/accounts/codes/bundleGrid`,
        lookup: `/accounts/codes`,
        resendBundle: code => `/accounts/codes/bundleGrid/${code}/resend`,
    },
    mobile: {
        deals: '/accounts/deals',
        editDeals: id => `/accounts/deals/${id}`,
        promoCodes: '/accounts/promoCodes',
        editPromoCodes: id => `/accounts/promoCodes/${id}`,
    },
    validate: {
        email: `/accounts/users/unique`,
        mediaID: `/accounts/users/unique/media`,
    },
    terminals: {
        ids: '/loyaltyAwards/terminals'
    },
    users: '/accounts/users',
    eventLog: id => `/accounts/merchants/${id}/eventLogs`,
    features: '/accounts/features',
    subscriptions: '/accounts/subscriptions',
    states: '/accounts/merchant/states',
    timeZones: '/timeZones',
    locations: {
        list: '/accounts/locations/all',
        labels: '/accounts/locations/labels',
        kiosks: id => `/accounts/locations/${id}/kiosks`,
        ksEndpointUsage: '/accounts/locations/ksEndpointUsage'
    },
    tooltips: '/tooltips',
    pageInfo: '/hsPages',
    translateAudit: '/accounts/audit/translate',
    menu: '/accounts/menu',
    updates: '/system/updates',
    forgotPassword: '/accounts/forgotPassword',
    surveys: guid => `/survey/responses?userid=${guid}`,
        LoyaltyPointAwards: {
        main: '/loyaltyPointAwards',
        id: id => `/loyaltyPointAwards/${id}`,
    }
}

export const PublicRoute = {
    company: '/ksu',
    uniqueEmail: '/ksu/unique',
    completion: '/ksu/setup',
    merge: '/ksu/merge',
}